import React from "react";
import PropTypes from "prop-types";
import { QueryUtility } from "core/utils";
import { QueryDropdownTemplate } from "themes/components";

class QueryDropdown extends React.Component {
    
    render() {
        return <QueryDropdownTemplate {...this.props} />;
    }
}

QueryDropdown.propTypes = {
    queryUtility: PropTypes.instanceOf(QueryUtility),
    propertyName: PropTypes.string,
    onChange: PropTypes.func,
    onClear: PropTypes.func
};

export default QueryDropdown;
